import BaseService from "@/services/BaseService";

export default class AccountService extends BaseService {
  constructor() {
    super('odoo/carrier');
  }

  findAllCarrier() {
    return this.http.get(`${this._serviceName}`);
  }

  findAllCarrierView() {
    return this.http.get(`${this._serviceName}/findAllCarrierView`);
  }

  findAllByParams(data) {
    return this.http.get(`${this._serviceName}/findAllByParams`, { params: data });
  }
}
